import { instance } from '@/apis/core';

import { MARKET_STATUS, MarketInfo, MarketInfoV2, MarketProduct, Pagination } from './types';

/** GET /v2/market/<id>/payment-info. key_encrypted가 false면 key는 평문 토스 클라이언트 키 */
export interface MarketPaymentInfo {
  status: MARKET_STATUS;
  key: string;
  key_encrypted?: boolean;
}

interface MarketRepositoryImpl {
  getMarket(username: string): Promise<MarketInfo>;
  getMarketV2(username: string): Promise<MarketInfoV2>;
  getMarketCampaigns(
    username: string,
    page: number,
    category: string,
  ): Promise<Pagination<MarketProduct>>;
  getMarketCampaignsV2(
    username: string,
    page: number,
    category: string,
  ): Promise<Pagination<MarketProduct>>;
  getMarketKey(market_id: number): Promise<MarketPaymentInfo>;
}

class MarketRepostiroy implements MarketRepositoryImpl {
  getMarket = async (username: string): Promise<MarketInfo> => {
    const { data } = await instance.get(`/market/${username}`);
    return data;
  };

  getMarketV2 = async (username: string): Promise<MarketInfoV2> => {
    const { data } = await instance.get(`/v2/market/${username}/main`);
    return data;
  };

  getMarketCampaigns = async (
    username: string,
    page: number,
    category: string,
  ): Promise<Pagination<MarketProduct>> => {
    const { data } = await instance.get(
      `/market/${username}/campaigns?page=${page}&category=${category}`,
    );
    return data;
  };

  getMarketCampaignsV2 = async (
    username: string,
    page: number,
    category: string,
  ): Promise<Pagination<MarketProduct>> => {
    const { data } = await instance.get(
      `/v2/market/${username}/campaigns?page=${page}&category=${category}`,
    );
    return data;
  };

  getMarketKey = async (market_id: number): Promise<MarketPaymentInfo> => {
    const { data } = await instance.get(`/v2/market/${market_id}/payment-info`);
    return data;
  };
}

export const market = new MarketRepostiroy();
